var _defs, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "78.352%",
    y1: "18.649%",
    x2: "17.32%",
    y2: "105.627%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F1FB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DFF",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88 13.572c0 .413.34.748.759.748a.753.753 0 0 0 .758-.748.753.753 0 0 0-.758-.749.753.753 0 0 0-.758.749Zm6.326 0c0 .413.34.748.758.748a.753.753 0 0 0 .758-.748.753.753 0 0 0-.758-.749.753.753 0 0 0-.758.749Zm6.779-5.193s-.224-1.89-1.25-2.986c0 0 .721-.384-.056-1.041 0 0-.693-.165-.832-.11 0 0-.36-1.205-1.082-1.507 0 0-.611-.146-.75.439 0 0-1.623-.815-2.796-1.02 0 0-2.996-.57-3.801-1.945 0 0-.174-.35-.742-.144 0 0-.542.424-.376 2.122 0 0 .046.348-2.266-1.113 0 0-.574-.146-.74.292 0 0-.295 1.04.074 1.808 0 0-1.332.237-1.906.803 0 0-.647.822.444.95 0 0-1.627.913-1.906 3.488 0 0-.032 1.807.555 3.81a2.254 2.254 0 0 0-.136 1.053 2.305 2.305 0 0 0 1.994 2.023 6.8 6.8 0 0 0 1.685 2.695A6.933 6.933 0 0 0 9 20a6.933 6.933 0 0 0 4.902-2.004 6.796 6.796 0 0 0 1.706-2.76 2.307 2.307 0 0 0 2.003-1.908 2.255 2.255 0 0 0-.218-1.39c.365-1.058.681-2.365.592-3.56ZM2.266 14.953a1.983 1.983 0 0 1-1.529-1.709 1.95 1.95 0 0 1 .003-.442c.147.422.325.845.537 1.256 0 0 .44.434.892.274.019.109.04.218.065.326l.032.295ZM9 19.684c-3.148 0-5.789-2.182-6.452-5.095l-.054-.493a1.37 1.37 0 0 0 .151-.22s.058-2.028 1.279-3.233c0 0 1.073.293 2.442-.457 0 0-.574.695-1.092 1.06 0 0-.297.712.37.786 0 0 2.053.383 4.107-.95 0 0-.111.676.87.474 0 0 .794-.018 2.071-.986 0 0 .278.457 1.323-.11 0 0-.027.904.805 2.302 0 0 .361.58.361 1.605 0 0 .095.077.237.145l-.085.524c-.82 2.686-3.348 4.648-6.333 4.648Zm8.295-6.406a1.986 1.986 0 0 1-1.589 1.622c.026-.096.049-.193.07-.29.25.014.526-.102.71-.56 0 0 .37-.68.746-1.666.09.29.112.595.063.894Z",
    fill: "url(#a)",
    fillRule: "nonzero"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleIcon);
export default __webpack_public_path__ + "static/media/male-icon.7598866c5822fbc0901bd9524291af7c.svg";
export { ForwardRef as ReactComponent };